<app-block-wrapper [_editable]="_editable" [style]="style">
  <app-picture
    [scale]="1"
    [loading]="loading"
    [url]="image.filename"
    [width]="dimensions.width"
    [height]="dimensions.height"
    [mobileUrl]="mobileImage?.filename"
    [mobileWidth]="mobileDimensions?.width"
    [mobileHeight]="mobileDimensions?.height"
    [class.shadow-box]="shadowBox"
    [alt]="image.alt | replaceText : replacer"
    [maxWidth]="maxWidth"
    *ngIf="dimensions"
  >
  </app-picture>

  <div *ngIf="image && !image.filename" class="empty">EMPTY IMAGE BLOCK</div>
</app-block-wrapper>
